import { FlightSelectorDesktop } from '@/react-pages/Prices/TransportSelector/FlightSelector/FlightSelectorDesktop';
import { FlightSelectorMobile } from '@/react-pages/Prices/TransportSelector/FlightSelector/FlightSelectorMobile';
import { FlightTypeInfo } from '@/react-pages/Prices/TransportSelector/FlightSelector/FlightTypeInfo';
import { useBreakpoints } from '@/scopes/common/components/utils/breakpoints';
import { useFlightSelector } from '@/domain/prices/transports/hooks';
import { UnavailableContentDialog, Button } from '@sunwebgroup/ui-components';
import { useIntl } from '@/intl';
import { useSendFlight } from '@/domain/prices/analytics/useSendFlight';

export const FlightSelector = () => {
  const intl = useIntl();
  const { isDesktopSm } = useBreakpoints();
  const { isError } = useFlightSelector();
  useSendFlight();

  if (isError) {
    return (
      <UnavailableContentDialog
        title={intl.formatMessage({ id: 'prices_flight_selector_error_title' })}
        message={intl.formatMessage({ id: 'prices_flight_selector_error_message' })}
      >
        <Button onClick={() => window.location.reload()}>
          {intl.formatMessage({ id: 'prices_error_reload_button' })}
        </Button>
      </UnavailableContentDialog>
    );
  }

  return (
    <>
      {isDesktopSm ? <FlightSelectorDesktop /> : <FlightSelectorMobile />}
      <FlightTypeInfo />
    </>
  );
};
